import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "date-range-picker flex max-w-sm" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  class: "text-xs text-gray-500",
  for: "startDate"
}, "開始日", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "px-1 pt-7" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "-")
], -1)
const _hoisted_5 = { class: "w-full" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "text-xs text-gray-500",
  for: "endDate"
}, "終了日", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_date_picker, {
        id: "startDate",
        modelValue: _ctx.startDate,
        "onUpdate:modelValue": _ctx.updateStartDate,
        type: "date",
        placeholder: "開始日を選択",
        style: {"width":"100%"}
      }, null, 8, ["modelValue", "onUpdate:modelValue"])
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createVNode(_component_el_date_picker, {
        id: "endDate",
        modelValue: _ctx.endDate,
        "onUpdate:modelValue": _ctx.updateEndDate,
        type: "date",
        placeholder: "終了日を選択",
        style: {"width":"100%"}
      }, null, 8, ["modelValue", "onUpdate:modelValue"])
    ])
  ]))
}